import { GameOrientation } from '@/shared/api/game/types';

export const getOrientation = (): GameOrientation =>
  window.innerWidth > window.innerHeight
    ? GameOrientation.LANDSCAPE
    : GameOrientation.PORTRAIT;
